import { reactive } from 'vue';

class ErrorBag {

  constructor() {
    this.items = reactive([]);
  }

  has(field) {
    return this.items.some((e)=> e.field === field);
  }

  first(field) {
    return this.items.find((e)=> e.field === field)?.msg ?? null;
  }

  add({ field, msg }) {
    this.items.push({ field, msg });
  }

  remove(field) {
    const idx = this.items.findIndex((e)=> e.field === field);
    if (idx > -1) this.items.splice(idx, 1);
  }

  clear() {
    this.items.splice(0);
  }
}

const errors = new ErrorBag();

export function addErrors(messages) {
  errors.clear();
  messages.forEach((m)=> errors.add({ field: m.key, msg: m.error }));
}

export default errors;
